/*codice originale
const _=()=>{const S=window.themeCore.utils.debounce,g=window.themeCore.utils.cssClasses,c={form:".js-predictive-search-form",input:".js-predictive-search-input",searchBody:".js-predictive-search-body",resultContainer:".js-predictive-search-result-container",searchType:"input[name='type']",applyButton:".js-predictive-search-apply-button",resultRow:".js-predictive-search-result-row",tabsButton:".js-predictive-search-tabs-button",preloader:".js-preloader",searchPopup:"#headerPopupSearch",resultWrapper:".js-predictive-search-results",footer:".js-predictive-search-footer",activeTab:".js-predictive-search-tabs-button.is-active",featuredItems:".js-predictive-search-featured-items"},n={disabled:"disabled",id:"id",dataId:"data-id",ariaExpanded:"aria-expanded",ariaHidden:"aria-hidden"},r={visuallyHidden:"visually-hidden",emptySearchBody:"predictive-search__body--empty",...g},C=8;let m={};const h=document.querySelector(c.preloader),u=document.querySelector(c.footer),a=document.querySelector(c.resultContainer),v=a?a.innerHTML:null,f=document.querySelector(c.featuredItems),l=document.querySelector(c.searchBody),d=document.querySelector(c.applyButton);async function T(o){const t=o.target.closest(c.input);if(!document.querySelector(c.searchPopup)||!t||!a)return;const s=t.value.trim();if(!s.length){d&&d.setAttribute(n.disabled,n.disabled),d&&d.setAttribute(n.ariaHidden,"true"),p(a),u&&u.classList.add(r.hidden),a.innerHTML=v,!f&&a.classList.add(r.hidden),l&&l.classList.remove(r.emptySearchBody);return}if(E(),m[s]){b(m[s],a,d),y(),u&&u.classList.remove(r.hidden);return}const i=await q(s),w=new DOMParser().parseFromString(await i.text(),"text/html");m[s]=w,b(w,a,d),y(),u&&u.classList.remove(r.hidden)}function A(){a&&(d&&d.setAttribute(n.disabled,n.disabled),d&&d.setAttribute(n.ariaHidden,"true"),p(a),a.innerHTML=v,u&&u.classList.add(r.hidden),!f&&a.classList.add(r.hidden),l&&l.classList.remove(r.emptySearchBody))}function E(){h&&h.classList.add(r.active)}function y(){h&&h.classList.remove(r.active)}function b(o,t,e){p(t),e&&e.removeAttribute(n.disabled),e&&e.removeAttribute(n.ariaHidden);const s=o.querySelector(c.resultWrapper);if(!s){e&&e.setAttribute(n.disabled,n.disabled),e&&e.setAttribute(n.ariaHidden,"true"),R(t),t.classList.remove(r.hidden),l&&l.classList.add(r.emptySearchBody);return}t.innerHTML=s.innerHTML,t.classList.remove(r.hidden),l&&l.classList.remove(r.emptySearchBody),window.themeCore.EventBus.emit("compare-products:init"),window.themeCore.EventBus.emit("favorites-list:init"),document.addEventListener("click",H)}function H(o){const t=[...document.querySelectorAll(c.tabsButton)],e=[...document.querySelectorAll(c.resultRow)],s=o.target.closest(c.tabsButton);!s||!t.length||!e.length||(t.forEach(i=>{i.classList.remove(r.active),i.setAttribute(n.ariaExpanded,!1)}),s.classList.add(r.active),s.setAttribute(n.ariaExpanded,!0),e.forEach(i=>{i.classList.remove(r.active),i.classList.add(r.visuallyHidden)}),e.filter(i=>i.dataset.id===s.dataset.id).forEach(i=>{i.classList.add(r.active),i.classList.remove(r.visuallyHidden)}))}function R(o){var e,s,i;const t=`
				<p class="h4 predictive-search__result-empty">
					${((i=(s=(e=window.themeCore)==null?void 0:e.objects)==null?void 0:s.settings)==null?void 0:i.predictive_search_no_result)||window.themeCore.translations.get("general.predictive_search.no_results")}
				</p>
			`;o.innerHTML+=t}async function q(o){const t=document.querySelector(c.searchType);if(!t)return;const e=`${encodeURIComponent("resources[type]")}=${t.value}`,s=`${encodeURIComponent("resources[limit]")}=${C}`,i=`${window.Shopify.routes.root}search/suggest?q=${encodeURIComponent(o)}&${e}&${s}&section_id=predictive-search`;return await fetch(i)}function p(o){o.innerHTML=""}function j(o){const t=o.target.closest(c.form);if(!t)return;o.preventDefault();const e=t.querySelector(c.input).value.trim();e.length&&B(e)}function B(o){const t=document.querySelector(c.activeTab);if(!t)return;const e=encodeURI(o),s=`${window.Shopify.routes.root}search/?type=${t.getAttribute(n.dataId)}&options%5Bprefix%5D=last&q=${e}`;window.location.replace(s)}function P(){document.addEventListener("input",S(T,200,!1)),document.addEventListener("reset",A),document.addEventListener("submit",j)}return Object.freeze({init:P})},L=()=>{window.themeCore.PredictiveSearch=window.themeCore.PredictiveSearch||_(),window.themeCore.utils.register(window.themeCore.PredictiveSearch,"predictive-search")};window.themeCore&&window.themeCore.loaded?L():document.addEventListener("theme:all:loaded",L);
*/

/* Modifica applicata da me con riscrizone completa del file originale scritto sopra */

const PredictiveSearch = () => {
  const debounce = window.themeCore.utils.debounce;
  const cssClasses = window.themeCore.utils.cssClasses;

  const selectors = {
    form: ".js-predictive-search-form",
    input: ".js-predictive-search-input",
    searchBody: ".js-predictive-search-body",
    resultContainer: ".js-predictive-search-result-container",
    searchType: "input[name='type']",
    applyButton: ".js-predictive-search-apply-button",
    resultRow: ".js-predictive-search-result-row",
    tabsButton: ".js-predictive-search-tabs-button",
    preloader: ".js-preloader",
    searchPopup: "#headerPopupSearch",
    resultWrapper: ".js-predictive-search-results",
    footer: ".js-predictive-search-footer",
    activeTab: ".js-predictive-search-tabs-button.is-active",
    featuredItems: ".js-predictive-search-featured-items"
  };

  const attributes = {
    disabled: "disabled",
    id: "id",
    dataId: "data-id",
    ariaExpanded: "aria-expanded",
    ariaHidden: "aria-hidden"
  };

  const classes = {
    visuallyHidden: "visually-hidden",
    emptySearchBody: "predictive-search__body--empty",
    ...cssClasses
  };

  const RESULT_LIMIT = 8;
  let searchCache = {};

  const preloader = document.querySelector(selectors.preloader);
  const footer = document.querySelector(selectors.footer);
  const resultContainer = document.querySelector(selectors.resultContainer);
  const defaultResultHTML = resultContainer ? resultContainer.innerHTML : null;
  const featuredItems = document.querySelector(selectors.featuredItems);
  const searchBody = document.querySelector(selectors.searchBody);
  const applyButton = document.querySelector(selectors.applyButton);

  async function handleInput(event) {
    const inputElement = event.target.closest(selectors.input);
    if (!document.querySelector(selectors.searchPopup) || !inputElement || !resultContainer) {
      return;
    }

    const query = inputElement.value.trim();
    if (!query.length) {
      resetSearch();
      return;
    }

    showPreloader();

    if (searchCache[query]) {
      renderResults(searchCache[query]);
      hidePreloader();
      return;
    }

    const response = await fetchResults(query);
    const parsedResponse = new DOMParser().parseFromString(await response.text(), "text/html");

    searchCache[query] = parsedResponse;
    renderResults(parsedResponse);
    hidePreloader();
  }

  function resetSearch() {
    if (resultContainer) {
      applyButton && applyButton.setAttribute(attributes.disabled, attributes.disabled);
      applyButton && applyButton.setAttribute(attributes.ariaHidden, "true");

      resultContainer.innerHTML = defaultResultHTML;
      resultContainer.classList.add(classes.hidden);

      if (!featuredItems) {
        resultContainer.classList.add(classes.hidden);
      }

      searchBody && searchBody.classList.remove(classes.emptySearchBody);
    }
  }

  function showPreloader() {
    preloader && preloader.classList.add(classes.active);
  }

  function hidePreloader() {
    preloader && preloader.classList.remove(classes.active);
  }

  function renderResults(response) {
  if (!resultContainer) return;

  // Rimuove eventuali attributi disabilitati
  applyButton && applyButton.removeAttribute(attributes.disabled);
  applyButton && applyButton.removeAttribute(attributes.ariaHidden);

  const resultWrapper = response.querySelector(selectors.resultWrapper);

  // Se non ci sono risultati
  if (!resultWrapper) {
    applyButton && applyButton.setAttribute(attributes.disabled, attributes.disabled);
    applyButton && applyButton.setAttribute(attributes.ariaHidden, "true");

    // Mostra il messaggio "Nessun risultato"
    resultContainer.innerHTML = `
      <p style="
        font-family: 'Inter Medium', sans-serif;
        font-size: 16px;
        color: #333;
        text-align: center;
        margin-top: 20px;
      ">
        Nessun risultato
      </p>
    `;
    resultContainer.classList.remove(classes.hidden);
    searchBody && searchBody.classList.add(classes.emptySearchBody);
    return;
  }

  // Se ci sono risultati, aggiorna il contenuto
  resultContainer.innerHTML = resultWrapper.innerHTML;
  resultContainer.classList.remove(classes.hidden);
  searchBody && searchBody.classList.remove(classes.emptySearchBody);

  // Aggiunge un gestore per il cambio dei tab (se necessario)
  document.addEventListener("click", handleTabSwitch);
}


  function handleTabSwitch(event) {
    const tabs = [...document.querySelectorAll(selectors.tabsButton)];
    const resultRows = [...document.querySelectorAll(selectors.resultRow)];
    const clickedTab = event.target.closest(selectors.tabsButton);

    if (!clickedTab || !tabs.length || !resultRows.length) return;

    tabs.forEach(tab => {
      tab.classList.remove(classes.active);
      tab.setAttribute(attributes.ariaExpanded, "false");
    });

    clickedTab.classList.add(classes.active);
    clickedTab.setAttribute(attributes.ariaExpanded, "true");

    resultRows.forEach(row => {
      row.classList.add(classes.visuallyHidden);
      row.classList.remove(classes.active);
    });

    resultRows
      .filter(row => row.dataset.id === clickedTab.dataset.id)
      .forEach(row => {
        row.classList.remove(classes.visuallyHidden);
        row.classList.add(classes.active);
      });
  }

  function showNoResultsMessage() {
    if (!resultContainer) return;

    const noResultsMessage = `
      <p class="h4 predictive-search__result-empty">
        ${window.themeCore.translations.get("general.predictive_search.no_results")}
      </p>
    `;

    resultContainer.innerHTML += noResultsMessage;
  }

  async function fetchResults(query) {
    const searchType = document.querySelector(selectors.searchType);
    if (!searchType) return;

    const queryParams = [
      `${encodeURIComponent("resources[type]")}=${searchType.value}`,
      `${encodeURIComponent("resources[limit]")}=${RESULT_LIMIT}`,
      `${encodeURIComponent("resources[options][fields]")}=title,product_type,variants.barcode,variants.sku,variants.title,tag,vendor`,
      `q=${encodeURIComponent(query)}`
    ];

    const requestUrl = `${window.Shopify.routes.root}search/suggest?${queryParams.join("&")}&section_id=predictive-search`;
    return await fetch(requestUrl);
  }

  function init() {
    document.addEventListener("input", debounce(handleInput, 200, false));
    document.addEventListener("reset", resetSearch);
    document.addEventListener("submit", handleSubmit);
  }

  function handleSubmit(event) {
    const form = event.target.closest(selectors.form);
    if (!form) return;

    event.preventDefault();
    const query = form.querySelector(selectors.input).value.trim();
    if (query.length) {
      performSearch(query);
    }
  }

  function performSearch(query) {
    const activeTab = document.querySelector(selectors.activeTab);
    if (!activeTab) return;

    const searchUrl = `${window.Shopify.routes.root}search/?type=${activeTab.getAttribute(attributes.dataId)}&q=${encodeURIComponent(query)}`;
    window.location.replace(searchUrl);
  }

  return {
    init
  };
};

const initPredictiveSearch = () => {
  window.themeCore.PredictiveSearch = PredictiveSearch();
  window.themeCore.PredictiveSearch.init();
};

window.themeCore && window.themeCore.loaded
  ? initPredictiveSearch()
  : document.addEventListener("theme:all:loaded", initPredictiveSearch);